/* eslint-disable no-param-reassign */
import Promise from 'bluebird';
import $ from 'jquery';
import _, { noop, extend, chain } from 'underscore';

import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { FilterService } from '@bingads-webui/filter-service';
import { getCampaignsGridFactory, dummyDataSource } from '@bingads-webui-campaign/campaigns-grid';
import { WaterfallFilterStorage, WaterfallFilterType, waterfallDateFilterProcessor } from '@bingads-webui-campaign/filter-storage';
import { getGridPreferences } from '@bingads-webui-campaign/summary-grid-helper';
import { getRouterDep } from '@bingads-webui-campaign-react/legacy-router-dep';
import { getGridName } from '@bingads-webui-campaign/inline-download-grids-metadata';
import { getDataSourceWithInjection, getFilterConfigWithInjection } from '@bingads-webui-campaign/campaigns-data';
import { Label } from '@bingads-webui-campaign/campaign-ui-schemas';
import { getFilteredCampaignTypeFromRawFilter } from '@bingads-webui-campaign-react/shell-ui-common';

import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
import * as SegmentationPreference from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import * as fetchPagination from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
import state from '@bingads-webui-component-legacy/state/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import cacheService from '@bingads-webui-static-legacy/cache-service';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';
import cacheManager from '@bingads-webui-campaign-legacy/cache-manager/index';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import { LabelAssociationView } from '@bingads-webui-campaign-legacy/common-grid-plugins/label/label-association-view';
import preferenceServiceLegacy from '@bingads-webui-component-legacy/preference/service/index';
import segmentTimeChecker from '@bingads-webui-component-legacy/bingads-grid/shared/timeRangeChecker';
import ChangeStatusView from '@bingads-webui-static-legacy/bulk-edit/view/campaign/changeStatus';
import ChangeStatusModel from '@bingads-webui-static-legacy/bulk-edit/model/campaign/changeStatus';
import ChangeBidStrategyModel from '@bingads-webui-static-legacy/bulk-edit/model/shared/changeBiddingStrategy';
import ChangeBidStrategyView from '@bingads-webui-static-legacy/bulk-edit/view/shared/changeBiddingStrategy';
import ChangeLanguageView from '@bingads-webui-campaign-legacy/campaign-bulk-edit/view/bulkEditLanguage';
import ChangeLanguageModel from '@bingads-webui-campaign-legacy/campaign-bulk-edit/model/bulkEditLanguage';
import CopyPaste from '@bingads-webui-static-legacy/bulk-edit/view/copyPaste';
import azureUrlRewrite from '@bingads-webui-static-legacy/app/component/azureUrlRewrite';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import { getFilters } from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import * as ColumnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import { fetchSortInfo } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-sortinfo';
import { getColumnsMap, getBaseColumnsByType } from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/columns-config-base';
import logger from '@bingads-webui-static-legacy/instrumentation/index';

import { getAdditionalPlugins } from './additional-plugins';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');
const legacyGlobalI18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');
const i18nGlobal = window.globalLegacyI18n.get('$/i18n!global');
const schemaI18nCampaign = window.globalLegacyI18n.get('$/schema-i18n!campaign');

const campaignsGridPromiseFactory = () => getCampaignsGridFactory()();

export function createCampaignsGridForUiNext({
  serverContext,
  toolbarPlugin,
  preferenceService,
  scope,
  permissions,
  crossPageSelectPlugin,
  newI18n,
  siteMap,
  perfMarker,
  pageName,
  willParentViewUnMount,
  deps = {},
  preexecuteFlag = false,
  theme,
  campaignUpgradeProps,
}) {
  return new Promise((resolve) => {
    campaignsGridPromiseFactory({
      serverContext,
      scope,
      permissions,
      siteMap,
      preferenceService,
      deps,
    }).then(({ createCampaignsGrid }) => {
      const legacyDeps = {
        customColumnPreference,
        jsData,
        appConfig,
        i18n,
        sessionStore,
        preferenceStoreFactory: getFilters,
        legacyGlobalI18n,
        schemaI18nCampaign,
        cacheService,
        dataContextManager,
        edm,
        ColumnChooserPreference,
        SegmentationPreference,
        fetchPagination,
        dateUtil,
        state,
        fetchSortInfo,
        getColumnsMap,
        getBaseColumnsByType,
        logger,
      };

      const { getSegPreference, getSegType } = SegmentationPreference;
      const { fetchPaginationConfig } = fetchPagination;

      const gridName = getGridName('Campaign');

      let errorId = null;
      let flucActivity = null;
      const headerRefreshCache = 'x-ms-refreshcampaigncache';


      const fluctuationScenario = instrumentation.fluctuation.create();
      if (fluctuationScenario && fluctuationScenario.fluctuationInstr) {
        flucActivity = fluctuationScenario.fluctuationInstr.create();
      }

      function afterFindAll(resources, attrs, options = {}) {
        if (options.useDfmCache) {
          delete options.useDfmCache;
        }

        if (options.headers) {
          delete options.headers[headerRefreshCache];
        }

        if (errorId) {
          window.App.views.alertCenter.dismiss(errorId);
          errorId = null;
        }

        if (Array.isArray(attrs) && attrs.length) {
          attrs.forEach((v) => {
            if (v.AvailableInsightTypeIds && v.AvailableInsightTypeIds.length) {
              flucActivity.trace(`Fluctuations Rendered. FromScenario: CampaignsGrid, TypeIds: ${v.AvailableInsightTypeIds.toString()}, campaignId: ${v.Id}}.`);
            }
          });
        }
        const unfilteredTotals = attrs.raw['@ns.unfiltered.totals'];
        if (unfilteredTotals && unfilteredTotals.AvailableInsightTypeIds) {
          unfilteredTotals.AvailableInsightTypeIds.forEach((v) => {
            flucActivity.trace(`Overall Fluctuations Rendered. FromScenario: CampaignsGrid, TypeIds: ${v.toString()}.`);
          });
        }

        if (_.isArray(attrs)) {
          return attrs;
        }

        errorId = window.App.views.alertCenter.show({
          message: legacyGlobalI18n.getString('Manage_Error_Default'),
          level: 'Error',
          dismissible: true,
        });
        return {};
      }


      // merge the scopeService instance and scope entity object together
      const scopeAdapter = extend({
        customerId: scope.values.cid,
        accountId: scope.values.aid,
        campaignId: scope.values.campaignId,
      }, scope);

      const edmEntity = edm.currentAccount;
      const waterfallFilterStorage = new WaterfallFilterStorage({
        preferenceService,
      });

      const router = {
        getRouteTo: () => 'route',
        navigateToRoute: getRouterDep(scope, siteMap).navigateToRoute,
        getRoutePathById: pageId => getRoutePathById(siteMap, pageId),
      };

      getGridPreferences({
        gridName: 'summary_tab_campaign',
        dateUtil: {
          format: value => i18n.formatDate(value),
        },
        state,
        edm: edmEntity,
        getSegPreference,
        getSegType,
        segmentTimeChecker,
        fetchPaginationConfig,
        customColumnPreference,
      }).then((preferenceConfig) => {
        if (willParentViewUnMount()) {
          resolve({});
          return;
        }

        const dataSourceWithInjection = getDataSourceWithInjection({
          gridName,
          preferenceService,
          newI18n,
          serverContext,
          ..._.pick(
            legacyDeps,
            'customColumnPreference',
            'jsData',
            'appConfig',
            'i18n',
            'sessionStore',
            'preferenceStoreFactory',
            'legacyGlobalI18n',
            'schemaI18nCampaign',
            'cacheService',
            'dataContextManager',
            'edm',
            'ColumnChooserPreference',
            'SegmentationPreference',
            'fetchPagination',
            'dateUtil',
            'state',
            'fetchSortInfo',
            'getColumnsMap',
            'getBaseColumnsByType',
            'logger'
          ),
        });

        const { CampaignFilterImprovementEnabled } = permissions.dynamic;
        let customDataSource = null;
        let filterConfig = null;
        let filterService = null;
        if (CampaignFilterImprovementEnabled) {
          const {
            dataSource: cachedDataSource,
            filterService: cachedFilterService,
          } = dataSourceWithInjection;

          filterConfig = getFilterConfigWithInjection({
            preferenceService,
            newI18n,
            cachedEntitySchema: cachedFilterService.entitySchema, // use entitySchema from cahced service because it's flattened and pilots are alreayd applied to it.
            customColumnPreference,
            scope: scopeAdapter,
            ..._.pick(
              legacyDeps,
              'customColumnPreference',
              'jsData',
              'appConfig',
              'i18n',
              'sessionStore',
              'preferenceStoreFactory',
              'legacyGlobalI18n',
              'schemaI18nCampaign',
              'cacheService',
              'dataContextManager',
              'edm'
            ),
          });

          cachedFilterService.entitySchema = filterConfig.schemaProcessor(filterConfig.entitySchema);
          customDataSource = cachedDataSource;
          filterService = cachedFilterService;
        } else {
          customDataSource = dataSourceWithInjection;

          filterConfig = getFilterConfigWithInjection({
            preferenceService,
            newI18n,
            customColumnPreference,
            scope: scopeAdapter,
            ..._.pick(
              legacyDeps,
              'customColumnPreference',
              'jsData',
              'appConfig',
              'i18n',
              'sessionStore',
              'preferenceStoreFactory',
              'legacyGlobalI18n',
              'schemaI18nCampaign',
              'cacheService',
              'dataContextManager',
              'edm'
            ),
          });
          filterService = new FilterService(filterConfig);
        }

        if (customDataSource) {
          // eslint-disable-next-line no-underscore-dangle
          customDataSource._options.afterFindAll = (resources, attrs) => afterFindAll(resources, attrs, customDataSource._options);
          customDataSource.type = 'jsdata';
          customDataSource.queryBuilder.getDecoratorByName('filter').filterService = filterService;
        }

        const dataSource = preexecuteFlag ? dummyDataSource : customDataSource;
        const getCampaignTypeGlobalFilter = () => {
          const filters = waterfallFilterStorage.getFilters([WaterfallFilterType.CampaignType]);
          const rawFilter = chain(filters).first().result('filter').value();
          return getFilteredCampaignTypeFromRawFilter(rawFilter);
        };
        const gridView = createCampaignsGrid({
          addDateChangeListener: noop,
          p$daterange: () => {
            const dateFilter = waterfallDateFilterProcessor(
              waterfallFilterStorage.getFilters([WaterfallFilterType.DateFilter]),
              serverContext
            );
            return Promise.resolve(dateFilter);
          },
          dataSource,
          filterService,
          pageName,
          preexecuteFlag,
          theme,
          preferenceConfig,
          preferenceService,
          router,
          isDataFetchManagerSource: true,
          newI18n,
          getAdditionalPlugins: getAdditionalPlugins({
            gridName,
            ChangeStatusView,
            ChangeStatusModel,
            ChangeBidStrategyModel,
            ChangeBidStrategyView,
            ChangeLanguageView,
            ChangeLanguageModel,
            CopyPaste,
            i18nGlobal,
            edm,
            toolbarPlugin,
            filterService,
            scope: scopeAdapter,
            appConfig,
            cacheManager,
            crossPageSelectPlugin,
            i18n,
            newI18n,
            instrumentation,
            appState: state,
            odata,
            preferenceService: preferenceServiceLegacy,
            i18nErrors,
            jsData,
            LabelAssociationView,
            dataContextManager,
            cacheService,
            s$label: Label,
            router,
            permissions,
            deps,
            getCampaignTypeGlobalFilter,
            perfMarker,
            campaignUpgradeProps,
          }),
          scope: scopeAdapter,
          serverContext,
          instrumentation,
          isForVNext: true,
          viewport: $('.campaigns-page'),
          campaignTabPerfMarker: perfMarker,
          customHeaderOffset: () => $('.sticky-container').height(),
          azureUrlRewrite,
          getCampaignTypeGlobalFilter,
        });

        resolve({
          filterConfig,
          filterService,
          gridView,
          gridDataSource: dataSource,
          i18n,
        });
      });
    });
  });
}
